import React, { useState, useEffect, useContext } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { Row, Col} from 'react-bootstrap';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Pagination from '@mui/material/Pagination';
import { IconButton, Menu, MenuItem, Snackbar } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';

import './CommunityRoom.css'
import { apiGetCurrentUser, apiCreatePost, apiGetCommunityPosts, apiDeleteSpecificCommunityPost, apiLikeSpecificCommunityPost, apiGetSpecificCommunityPost, apiAdminDeletePost, apiGetUserByEmail } from '../api/api'
import { ReactComponent as BlankHeart } from '../img/like-blank.svg'
import { ReactComponent as FilledHeart } from '../img/like-filled.svg'
import { ReactComponent as EditIcon } from '../img/edit.svg'
import { ReactComponent as DeleteIcon } from '../img/delete.svg'
import { ReactComponent as ShareIcon } from '../img/share.svg'
import { CommunityContext } from './CommunityContext'
import { Avatar } from '@mui/material';
import placeholder_profile from '../img/avatar.jpg'

const CommunityRoom = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const [title, setTitle] = useState('');
  const [posts, setPosts] = useState('');
  const [content, setContent] = useState('');
  const [file, setFile] = useState('');
  const [actionTrigger, setActionTrigger] = useState(0);
  const [currentUser, setCurrentUser] = useState('');
  const { userData, setCurrentPost, memberData } = useContext(CommunityContext);
  const [status, setStatus] = useState();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")

  const createdAtFormat = (createdAt) => {
    return createdAt.substring(11,19) + ", " + createdAt.substring(0, 10)
  }

  const init = async () => {
    apiGetCurrentUser()
      .then(res => {
        console.log('current user: ' + res);
        setCurrentUser(res.data);
      })
      .catch(e => {
        console.log(e);
        e.response && alert(e.response.data.detail);
      });
  };

  const retrievePosts = (id, skip, limit) => {
    apiGetCommunityPosts(id, skip, limit)
      .then(res => {
        console.log(res);
        setPosts(res.data);
      })
      .catch(e => {
        console.log(e);
        e.response && alert(e.response.data.detail);
      });
  }
  

  const handleSubmit = async e => {
    e.preventDefault();
    const data = {
      'title': title,
      'content': content,
      'link': '',
      'likesCounter': 0,
      'username': currentUser.user.username,
      'creator': currentUser.user.email,
      'communityId': id,
      'isUpdated': false,
      'userLiked': [],
      'createdAt': new Date().toISOString(),
      'updatedAt': new Date().toISOString()
    }
    const formData = new FormData();
    formData.append('form_data', JSON.stringify(data));
    file && formData.append('file', file);
    console.log(formData);
    const result = await apiCreatePost(formData);
    if (result.data.status === 'accepted') {
      setStatus(
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Successfully create your post — <strong>Congrats!</strong>
        </Alert>
      )
      setTimeout(() => {
        setStatus()
        setActionTrigger(actionTrigger + 1)
      }, 2000);
    } else {
      setStatus(
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Something wrong with your input — <strong>Check again!</strong>
        </Alert>
      )
    }
  }

  const handleDelete = id => async e => {
    e.preventDefault();
    const result = await apiDeleteSpecificCommunityPost(id);

    if (result.data.status === 'deleted') {
      setConfirmDelete(false);
      setActionTrigger(actionTrigger + 1);
    }
  }

  const handleAdminDelete = id => async e => {
    e.preventDefault();
    const result = await apiAdminDeletePost(id);

    result.data.status === 'deleted by admin' && setActionTrigger(actionTrigger + 1);
  }

  const handleLike = (post, user) => async e => {
    e.preventDefault();
    post.userLiked.push(user);
    console.log('liked by', post.userLiked)
    post.likesCounter = post.userLiked.length;
    let content = posts.content.map(item => item._id === post._id ? post: item)
    setPosts((posts)=>({...posts, content}));
    try{
      await apiLikeSpecificCommunityPost(post._id);
    }
    catch(e){
      console.log(e)
      alert("an error has occured")
    }
  }

  const handleUnlike = (post, user) => async e => {
    e.preventDefault();
    let userLiked = post.userLiked.filter(item => {
      return item !== user;
    });
    post.userLiked = userLiked;
    post.likesCounter = userLiked.length;
    let content = posts.content.map(item => item._id === post._id ? post: item);
    setPosts((posts)=>({...posts, content}));
    try{
      await apiLikeSpecificCommunityPost(post._id);
    }
    catch(e){
      console.log(e)
      alert("an error has occured")
    }
  }
  const sharePost = (postId) => {
    let url = window.location.href
    const certainUrl = url + `/${postId}`
    navigator.clipboard.writeText(certainUrl)
    setSnackbarMessage("Post URL copied to clipboard")
    handleSnackbarOpen()
  }

  const openCertainPost = (post) => {
    console.log("open certain post", post._id)
    setCurrentPost(post)
    navigate(`/community/${id}/discussion/${post._id}`)
  }
    
  const handleSnackbarOpen = () => {
    setSnackbarOpen(true)
    setTimeout(() => setSnackbarOpen(false), 5000)
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  }

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackbarClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  useEffect(() => {
    init()
  }, []);

  useEffect(() => {
    retrievePosts(id, skip, limit);
    const inputs = document.querySelectorAll('#title__field, #post__field');
    inputs.forEach(input => {
      input.value = '';
    });
  }, [actionTrigger, id, skip, limit]);

  return (
    <>
      <div className="createPost">
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
          action={action}
        />
        {status && <div style={{marginBottom: '1rem'}}>{status}</div>}
        <h1 id="post__title">Create Post</h1>
        <form onSubmit={handleSubmit}>
          <input
            id='title__field'
            data-testid='title__field'
            type="text"
            placeholder='Title'
            autoComplete='off'
            maxLength={50}
            onChange={e => setTitle(e.target.value)}
            required
          />
          <textarea
            name="create-post"
            id="post__field"
            data-testid='post__field'
            rows="5"
            autoComplete='off'
            maxLength={255}
            onChange={e => setContent(e.target.value)}
            placeholder='Write a post...'
          />
          <label htmlFor="attach__file">Supported Image (png, jpg, jpeg, svg) *optional</label><br />
          <input type="file" name="attach__file" id="attach__file" data-testid="attach__file" onChange={e => setFile(e.target.files[0])} />
          <button id="submit__button" type="submit">Submit</button>
        </form>
      </div>
      { posts && posts.content.map((item, index) => {
        return (
          <div className="readPost" key={index}>
            <Row>
              <Col className='post-content-details'>
                <Row>
                    <Col className='post-avatar'>
                        <Avatar 
                          src={memberData[item.creator] && memberData[item.creator].avatar ? memberData[item.creator].avatar: placeholder_profile}
                          onClick={()=>{navigate(`/profile/${item.creator}`)}}
                          style={{cursor:"pointer"}}
                          />
                    </Col>
                    <Col>
                        <Link className='createdBy' to={`/profile/${item.creator}`}>
                          <p className='createdBy'>{item.username ? item.username : item.creator}</p>
                        </Link>
                        <p className='publishedAt'>Published at {createdAtFormat(item.createdAt)} {item.isUpdated && <> &#128900; <span id="edited__tag">edited</span></>}</p>
                    </Col>
                    <Col className='post-buttons'>
                {userData.email === item.creator ?
                  <>
                    {
                      confirmDelete.status && item._id === confirmDelete.id ?
                        <Alert severity="warning">
                          <AlertTitle>Warning</AlertTitle>
                          This is a delete action — <strong>Are you sure want to delete this post?</strong>
                          <div className='action__container__post'>
                            <button className='cancel__special__button' onClick={() => setConfirmDelete({ 'status': false, 'id': 'not valid' })}>No</button>
                            <form onSubmit={handleDelete(item._id)} type="submit">
                              <button type="submit">Yes</button>
                            </form>
                          </div>
                        </Alert>
                        :
                        <button onClick={() => setConfirmDelete({ 'status': true, 'id': item._id })} data-testid="button__delete" className='button__delete' type="submit">
                          <DeleteIcon />
                        </button>
                    }
                    <Link to={`/community/${id}/discussion/${item._id}/update`}>
                      <button className='button__update' title="edit">
                        <EditIcon />
                      </button>
                    </Link>
                  </>
                  :
                  ((userData.isAdmin) ?
                    <>
                      {
                        confirmDelete.status && item._id === confirmDelete.id ?
                          <Alert severity="warning">
                            <AlertTitle>Warning</AlertTitle>
                            This is a delete action — <strong>Are you sure want to delete this post?</strong>
                            <div className='action__container__post'>
                              <button className='cancel__special__button' onClick={() => setConfirmDelete({ 'status': false, 'id': 'not valid' })}>No</button>
                              <form onSubmit={handleAdminDelete(item._id)}>
                                <button type="submit" data-testid="confirm__delete">Yes</button>
                              </form>
                            </div>
                          </Alert>
                          :
                          <button onClick={() => setConfirmDelete({ 'status': true, 'id': item._id })} data-testid="button__delete" className='button__delete' type="submit">
                            <DeleteIcon />
                          </button>
                      }
                    </>
                    :
                    null
                  )}
                <button onClick={() => sharePost(`${item._id}`)}
                  className='button__share' title="share" data-testid="share-post" >
                  <ShareIcon />
                </button>
              </Col>
                </Row>
                <p className='postTitle'>{item.title}</p>
                    {item.attachment_url && (<div><img src={item.attachment_url} className='post-image' alt="image__postingan" /></div>)}
                <p className='postContent' style={{whiteSpace: "pre-line"}}>{item.content}</p>
              </Col>
            </Row>
            <div className='lower__button'>
              {
                item.userLiked.includes(currentUser.user.email) ? 
                <div className="likes">
                  <button className="unlikebutton" onClick={handleUnlike(item, currentUser.user.email)}>
                    <FilledHeart className='filledheart' />
                  </button>
                  <p>{item.likesCounter} {item.likesCounter < 2 ? 'Like': 'Likes'}</p> 
                </div>
                : 
                <div className="likes">
                  <button className="likebutton" onClick={handleLike(item, currentUser.user.email)}>
                    <BlankHeart className='blankheart' />
                  </button> 
                  <p>{item.likesCounter} {item.likesCounter < 2 ? 'Like': 'Likes'}</p> 
                </div>
              }
            </div>
            <div className='button_view_comments' onClick={()=>openCertainPost(item)}>View Comments</div>
          </div>
        )}
      )}
      <div className='pagination__container'>
      <Pagination count={5} onChange={(e, v) => {
          console.log(v);
          setSkip((v * 10) - 10);
          setLimit(v * 10);
          return retrievePosts(id, skip, limit);
        }} />
      </div>
    </>
  )
}
      
export default CommunityRoom
